import configureMockStore from 'redux-mock-store';

const middlewares = [];

const mockStore = configureMockStore(middlewares);

export const mockStoreWithData = mockStore({
  dashboard: {
    currentSubscription: 'currentSubscriptionOuid1',
  },
  localization: {
    locale: 'fr-fr',
  },
  loadingStatus: {},
  customer: {
    data: {
      name: 'Toto',
      givenName: 'Toto',
      familyName: 'Zoro',
      wallet: {
        amount: 8500,
      },
      paymentMeans: [
        {
          startDateTime: 0,
          functionalId: 'XXXXXXXXXXXX3055',
        },
      ],
    },
  },
  usage: {
    detailedUsages: [],
    summarizedUsages: {
      data: [
        {
          currentValue: 2621440,
          label: 'DATA_CREDIT',
          maxValue: 5242880,
          unitType: 'VOLUME',
        },
        {
          currentValue: 1015,
          label: 'EXTRA_CREDIT',
          maxValue: 2015,
          unitType: 'NUMBER',
        },
      ],
    },
  },
  newOffer: {
    options: [],
  },
  nextPlan: {},
  notifications: {
    data: [],
    loadingStatus: {},
  },
  payment: {
    paymentAuthentications: [],
  },
  subscriptions: {
    subscriptionsByOuid: {
      currentSubscriptionOuid1: {
        nextRenewalDate: 123456789123,
      },
    },
    subscriptionToUpdateOuid: '',
  },
  signUp: {
    availablePhoneNumbers: {
      shownPhoneNumbers: [],
    },
  },
  theme: 'Kaizen',
  voucher: {},
  wallet: { walletForfeitureData: {} },
});

export default mockStore;
